import { memo } from 'react';

import { Button, Modal } from 'antd';

function AppModal({
  cancelButtonHidden = false,
  cancelButtonText = 'Cancel',
  children,
  confirmButtonColor = 'primary',
  confirmButtonDisabled = false,
  confirmButtonHidden = false,
  confirmButtonText,
  footer,
  isOpen,
  loading = false,
  size = 'md',
  title,
  handleCancel,
  handleConfirm
}) {
  const width =
    size === 'lg'
      ? { xs: '90%', sm: '80%', md: '70%', lg: '60%', xl: '60%', xxl: '70%' }
      : { xs: '90%', sm: '80%', md: '70%', lg: '60%', xl: '50%', xxl: '40%' };

  return (
    <Modal
      maskClosable={false}
      width={width}
      open={isOpen}
      title={title}
      styles={{
        header: {
          textTransform: 'capitalize'
        },
        body: {
          paddingRight: '10px',
          maxHeight: '60vh',
          overflowY: 'auto',
          overflowX: 'hidden'
        }
      }}
      onOk={handleConfirm}
      onCancel={handleCancel}
      footer={
        footer ?? [
          <Button
            key="back"
            size="large"
            style={{ display: cancelButtonHidden ? 'none' : 'inline-block' }}
            onClick={handleCancel}>
            {cancelButtonText}
          </Button>,
          <Button
            key="submit"
            size="large"
            variant="solid"
            color={confirmButtonColor}
            disabled={confirmButtonDisabled}
            loading={loading}
            style={{ display: confirmButtonHidden ? 'none' : 'inline-block' }}
            onClick={handleConfirm}>
            {confirmButtonText}
          </Button>
        ]
      }>
      {children}
    </Modal>
  );
}

export default memo(AppModal);
